import {Inject, Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {BehaviorSubject} from 'rxjs';

import {HOME_URL} from 'app/common';
import {AuthUserService} from "./auth-user.service";
import {EnumLoginStatus, IUser} from "../interfaces";

@Injectable()
export class ReversalAuthGuard  {

  private readonly user: BehaviorSubject<IUser | null>;

  constructor(private authUserService: AuthUserService, private router: Router, @Inject(HOME_URL) private homeUrl: string) {
    this.user = this.authUserService.user$;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.user.value && this.user.value.loginStatus === EnumLoginStatus.LOGIN_PASSED) {
      this.router.navigateByUrl(this.homeUrl);
      return false;
    }
    return true;
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.canActivate(route, state);
  }
}
